import { ApiService } from "../utils/ApiService.js";
import { ApiCache } from "../utils/ApiCache.js";
import { SelloLocal } from "../utils/SelloLocal.js";

const CLAVE_STORAGE = "fenix_usuario";

export class AuthService {
  static async login(usuario, clave) {
    // PascalCase: es como declara el body el swagger del back (LoginRequest.Usuario/Clave).
    // ASP.NET liga sin distinguir mayúsculas, pero no depender de eso cuesta cero.
    const resp = await ApiService.post("auth/login", { Usuario: usuario, Clave: clave });
    if (resp?.status === 1 && resp.message?.Token) {
      // Igual que en logout(), pero hace falta tambien aca: se puede llegar al login sin haber
      // pasado por logout (token vencido, sesion abierta en otro dispositivo). Como los datos se
      // cachean sin vencimiento, sin esto las entradas del usuario anterior quedarian en
      // localStorage para siempre.
      ApiCache.invalidate({});
      SelloLocal.limpiar();
      ApiService.resetSesion();

      localStorage.setItem(CLAVE_STORAGE, JSON.stringify(resp.message));
      return { ok: true, usuario: resp.message };
    }
    return { ok: false, mensaje: resp?.message || "No pudimos validar tus datos." };
  }

  /**
   * datos: { TipoDocumento, Documento, Email, Clave }
   *
   * No van nombre, apellido ni teléfono: el back no los usa —la persona la resuelve por el
   * documento— y los datos del titular llegan después, en la respuesta del login.
   */
  static async registro(datos) {
    const resp = await ApiService.post("auth/registro", datos);
    return {
      ok: resp?.status === 1,
      mensaje: resp?.message || "No pudimos completar el registro.",
    };
  }

  static async recuperar(usuario) {
    const resp = await ApiService.post("auth/recuperar", { Usuario: usuario });
    return {
      ok: resp?.status === 1,
      mensaje: resp?.message || "No pudimos procesar la solicitud.",
    };
  }

  /**
   * Segundo tramo de "olvidé mi clave": el "sec" llega por el enlace del mail (ver
   * AuthController.renderRestablecer) y viaja al back junto con la clave nueva. Es un hash de un
   * solo uso y con vencimiento: el back responde status 0 si ya se usó o si expiró.
   *
   * Se llama "Sec" y no "Token" en todo el circuito —URL, body y base del back— para que no se
   * confunda con el token de sesión, que es el del header x-token y no tiene nada que ver.
   */
  static async restablecer(sec, clave) {
    const resp = await ApiService.post("auth/restablecer", { Sec: sec, Clave: clave });
    return {
      ok: resp?.status === 1,
      mensaje: resp?.message || "No pudimos actualizar tu clave.",
    };
  }

  static logout() {
    localStorage.removeItem(CLAVE_STORAGE);
    // Sin esto, el próximo usuario en el mismo navegador vería las pólizas cacheadas del anterior.
    ApiCache.invalidate({});
    SelloLocal.limpiar();
    ApiService.resetSesion();
    window.location.hash = "login";
  }

  static getUsuario() {
    const raw = localStorage.getItem(CLAVE_STORAGE);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      localStorage.removeItem(CLAVE_STORAGE);
      return null;
    }
  }

  static getToken() {
    return this.getUsuario()?.Token || null;
  }

  /** Nombre corto para el saludo del home. */
  static getNombreCorto() {
    const u = this.getUsuario();
    if (!u) return "";
    return (u.Nombre || "").split(" ")[0];
  }

  static async checkAuth() {
    return !!this.getToken();
  }
}
